import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-gestores",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./gestores.component.html"
})
export class GestoresComponent {}
